namespace RedBullMOBILE360.SalesApp {
    export class WalletTransferColumns {
        static columnsKey = 'SalesApp.WalletTransfer';
    }
}